// extracted by mini-css-extract-plugin
module.exports = {"errorStack":"ErrorStack_errorStack__3J3CO"};